export function isNewerCandidateRequest(incoming, current) {
    if (!incoming?.id) return false;
    if (!current?.id) return true;
    if (String(incoming.id) !== String(current.id)) {
        const created = Date.parse(incoming.created_at), previous = Date.parse(current.created_at);
        if (created !== previous && Number.isFinite(created) && Number.isFinite(previous)) return created > previous;
        return /^\d+$/.test(String(incoming.id)) && /^\d+$/.test(String(current.id)) && Number(incoming.id) > Number(current.id);
    }
    const updated = Date.parse(incoming.updated_at), previous = Date.parse(current.updated_at);
    if (Number.isFinite(updated) && Number.isFinite(previous) && updated !== previous) return updated > previous;
    return (current.approved == null && incoming.approved != null) || (!current.started && !!incoming.started) || (!current.pause_end && !!incoming.pause_end);
}
export function canSkipFaceValidation(process, stream, ready) {
    return !!ready && stream != null && process?.allow_face_validation_skip === true && process.face_validation == true;
}
